module.exports = __webpack_public_path__ + "assets/img/Slice 164(5).ebceac06.png";